const React = require('react');
const {
  createTheme,
} = require('@material-ui/core/styles');
const {
  ThemeProvider,
} = require('@material-ui/styles');
require('date-fns');
const {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} = require('@material-ui/pickers');
const DateFnsUtils = require('@date-io/date-fns').default;


/* eslint-disable quote-props */
const defaultTheme = createTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#5B47FF',
      },
    },
    MuiPickersCalendarHeader: {
      iconButton: {
        color: '#444',
        '&:hover': {
          color: '#000',
          backgroundColor: '#EEE',
        },
      },
    },
    MuiPickersYear: {
      root: {
        color: '#BBB',
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
        },
      },
      yearSelected: {
        color: '#000',
      },
    },
    MuiPickersDay: {
      day: {
        color: '#444',
      },
      daySelected: {
        backgroundColor: '#5B47FF',
        color: '#FFF',
        '&:hover': {
          backgroundColor: '#4B37EF',
        },
      },
      dayDisabled: {
        color: 'rgba(0, 0, 0, 0.38)',
      },
    },
  },
});


module.exports = ({
  className,
  helperText,
  picker,
  after,
  ...props
}) => {
  return (
    <div className={className || ''}>
      <div className="rlv">
        <ThemeProvider theme={defaultTheme}>
          <MuiPickersUtilsProvider
            utils={DateFnsUtils}
          >
            <KeyboardDatePicker
              margin="none"
              variant="dialog"
              inputVariant="outlined"
              format="dd.MM.yyyy"
              {...props}
              className={picker && picker.className || ''}
            />
          </MuiPickersUtilsProvider>
        </ThemeProvider>
        {after || null}
      </div>
    </div>
  );
};
